export const CALENDAR_GRID_DAY_POPOVER_SKELETON_ROWS_LENGTH = 3
